import { useState } from "react";
import { Outlet } from "react-router-dom";

import { Layout } from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import Sider from "antd/es/layout/Sider";

import Header from "js/components/Header";
import Navigation from "js/components/Navigation";
import WhatsAppButton from "js/components/WhatsAppButton";

import "styles/pages/Dashboard/Dashboard.scss";

const { Content } = Layout;

const DashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Layout id={"dashboard"} hasSider>
      {/* Backdrop overlay for mobile menu */}
      {isMobile && !collapsed && (
        <div
          className="mobile-nav-backdrop"
          onClick={() => setCollapsed(true)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 999,
            cursor: "pointer",
          }}
        />
      )}

      {isMobile ? (
        <Sider
          width={260}
          collapsible
          onCollapse={setCollapsed}
          collapsedWidth={0}
          collapsed={collapsed}
          breakpoint="md"
          trigger={null}
          theme="light"
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 1000,
            overflow: "auto",
            height: "100vh",
          }}
          zeroWidthTriggerStyle={{ top: 24, left: 8 }}
        >
          <Navigation
            isMobile={isMobile}
            setCollapsed={setCollapsed}
            collapsed={collapsed}
          />
        </Sider>
      ) : (
        <Sider
          width={260}
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          trigger={null}
          theme="light"
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Navigation
            isMobile={isMobile}
            setCollapsed={setCollapsed}
            collapsed={collapsed}
          />
        </Sider>
      )}

      <Layout
        className="site-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 80 : 260,
          transition: "margin-left 0.2s",
          height: "100vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header setNavCollapsed={setCollapsed} isNavCollapsed={collapsed} />
        <WhatsAppButton />
        <Content
          style={{
            padding: 24,
            background: "#f2f5f9",
            overflow: "auto",
            flex: 1,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
